"use client";

import { FormEvent, useState } from "react";
import Link from "next/link";
import { useParams, useRouter } from "next/navigation";

export default function GuestSignupPage() {
  const params = useParams<{ slug: string }>();
  const router = useRouter();

  const slug = params.slug;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setError(null);
    setIsSaving(true);

    try {
      const apiUrl = process.env.NEXT_PUBLIC_API_URL;

      if (!apiUrl) {
        throw new Error("NEXT_PUBLIC_API_URL is niet ingesteld.");
      }

      if (password.length < 8) {
        throw new Error("Password moet minimaal 8 tekens bevatten.");
      }

      const res = await fetch(`${apiUrl}/auth/guest/signup`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_slug: slug,
          email,
          password,
        }),
      });

      if (!res.ok) {
        const message = await res.text().catch(() => "");
        throw new Error(
          message || `Account aanmaken mislukt (${res.status})`
        );
      }

      router.push(`/c/${slug}/rooms`);
      router.refresh();
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Onbekende fout bij account aanmaken"
      );
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <main style={{ padding: 24, maxWidth: 520 }}>
      <h1>Guest signup</h1>

      <form
        onSubmit={onSubmit}
        style={{ display: "grid", gap: 12 }}
      >
        <label style={{ display: "grid", gap: 6 }}>
          <span>E-mail</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ padding: 8 }}
          />
        </label>

        <label style={{ display: "grid", gap: 6 }}>
          <span>Password (minimaal 8 tekens)</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
            style={{ padding: 8 }}
          />
        </label>

        <button
          type="submit"
          disabled={isSaving}
          style={{ padding: 10 }}
        >
          {isSaving ? "Account aanmaken…" : "Account aanmaken"}
        </button>

        {error && <p style={{ color: "crimson" }}>{error}</p>}
      </form>

      <p style={{ marginTop: 20 }}>
        Heb je al een account?{" "}
        <Link href={`/c/${slug}/guest/login`}>
          Inloggen
        </Link>
      </p>

      <p>
        <Link href={`/c/${slug}/rooms`}>
          ← Terug naar kamers
        </Link>
      </p>
    </main>
  );
}